module.exports = __webpack_public_path__ + "assets/img/7712276e133d97b3c1e4ba76e1369307.png";